var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-container',[_c('HeaderMain',{attrs:{"title":"Задать вопрос"}}),_c('ContainerFormQuestion')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }